import {
  anEntityInterface,
  anInsightPage,
  aSignalPage,
  mockEntityDetailsInsightsSignalsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockEntityDetailsInsightsSignalsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          // SignalFragments alias contentTypeEnum to contentType, causing a type discrepancy
          // @ts-expect-error
          entity: anEntityInterface(),
          insights: anInsightPage(),
          // SignalFragments alias contentTypeEnum to contentType, causing a type discrepancy
          // @ts-expect-error
          signals: aSignalPage(),
        },
      });
    }
  ),
];
